import { AdapterOptions, AnalyticsAdapter } from '../../analyticsService.d';
import { analyticsUtils } from '../../analyticsUtils';

declare global {
  interface Window {
    smartlook?: any;
  }
}

export const smartlook = (
  instanceOptions?: AdapterOptions,
): AnalyticsAdapter => {
  const options = instanceOptions;

  function log(message: string): void {
    try {
      if (options?.debug) {
        options.logger(`SL: ${message}`);
      }
    } catch (error) {
      console.log(`SL: log error: ${error}`);
    }
  }

  function addVendor(): void {
    if (!verifyVendor()) {
      const w = window;
      w.smartlook = function () {
        w.smartlook.api.push();
      };
      w.smartlook.api = [];

      const head = window.document.getElementsByTagName('head')[0];
      const script = window.document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.crossOrigin = 'anonymous';
      script.src = 'https://web-sdk.smartlook.com/recorder.js';
      head.appendChild(script);

      log('addVendor - web-sdk.smartlook.com/recorder.js');
    } else {
      log('addVendor - `smartlook` already added');
    }
  }

  function verifyVendor(): boolean {
    return typeof window !== 'undefined' && !!window.smartlook;
  }

  function initialise(id: string): boolean {
    if (!verifyVendor() || !id) {
      return false;
    }

    window.smartlook('init', id);
    window.smartlook('anonymize');

    log(`initialise: ${id}`);
    return true;
  }

  function grantConsent(): void {
    if (verifyVendor()) {
      window.smartlook('resume');
    }
  }

  function revokeConsent(): void {
    if (verifyVendor()) {
      window.smartlook('disable');
    }
  }

  function pageView(path = ''): void {
    if (verifyVendor()) {
      window.smartlook('navigation', path);
      log('pageView');
    }
  }

  function trackEvent(data: Record<string, unknown>): void {
    const requiredData = analyticsUtils.getGenericData(data);

    if (verifyVendor()) {
      const title = `${requiredData.section} ${requiredData.label}`;
      const smartlookData = analyticsUtils.dataConverter(requiredData);
      window.smartlook('track', title, smartlookData);

      log(`track - ${title}`);
    }
  }

  return {
    addVendor,
    grantConsent,
    initialise,
    pageView,
    revokeConsent,
    trackEvent,
    verifyVendor,
  };
};
